import type React from 'react';
import { StyledRow } from './styles';

export interface RowProps {
  children?: React.ReactNode;
  className?: string;
  size?: 'zero' | 'sm' | 'md' | 'lg' | 'xl';
  flex?: boolean;
}

const Row: React.FC<RowProps> = ({ children, className, size, flex, ...rest }) => {
  return (
    <StyledRow size={size} flex={flex} className={className} {...rest}>
      {children}
    </StyledRow>
  );
};

export default Row;
